import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ShellComponent } from './shell.component';

@NgModule({
  imports: [CommonModule, IonicModule, RouterModule],
  declarations: [ShellComponent],
})
export class ShellModule {}
